<div data-cy="choose-enrollment-offer-step">
  <app-choose-enrollment-offer-form></app-choose-enrollment-offer-form>
</div>
